import Util from '@/helper/Utility.js';

export function PDPAModel() {
    this.termandcondition = 1;
    this.dataprivacy = 1;
    this.marketingOption = 1;
    this.consentAge = 20;
    this.email = 0;
    this.sms = 0;
    this.notification = 0;
    this.line = 0;

    this.setPDPAModel = function (data) {
        if (!data) return;

        this.termandcondition = data.termandcondition;
        this.dataprivacy = data.dataprivacy;
        this.marketingOption = data.marketingOption;
        this.consentAge = data.consentAge;
        this.email = data.email ? 1 : 0;
        this.sms = data.sms ? 1 : 0;
        this.notification = data.notification ? 1 : 0;
        this.line = data.line ? 1 : 0;
    };

    this.setDataFromApi = function (data) {
        this.termandcondition = data.TermAndCondition;
        this.dataprivacy = data.DataPrivacy;
        this.marketingOption = data.MarketingOption;
        this.consentAge = data.ConsentAge;
        this.email = data.EmailMarketing;
        this.sms = data.SMSMarketing;
        this.notification = data.NotificationMarketing;
        this.line = data.LineMarketing;
    };

    this.getParams = function () {
        let params = {
            termandcondition: this.termandcondition,
            dataprivacy: this.dataprivacy,
            marketingOption: this.marketingOption,
            consentAge : this.consentAge,
            email : this.email,
            sms : this.sms,
            notification : this.notification,
            line : this.line,
        };

        return Util.cleanObjectNullKey(params);
    };
}
